import { Reveal, SectionTitle } from "@/components/ui-bits";

const objetivos = [
  "Generar conversaciones de temas urgentes en colegios, universidades, centros culturales, centros de apoyo comunitario, etc. sobre autoestima, imagen corporal, relaciones sanas, salud mental y prevención de la violencia emocional.",
  "Realizar talleres, charlas y conversatorios gratuitos sobre los temas de la película y materiales derivados de la misma, garantizando un acceso inclusivo a la cultura.",
  "Desarrollar guías pedagógicas gratuitas basadas en la película, en alianza con iniciativas educativas afines y profesionales de la educación y la salud mental.",
  "Articular campañas con voces jóvenes e inspiradoras, promoviendo el mensaje de que ninguna adolescente debe enfrentarse sola a la inseguridad o presión emocional.",
];

const aliados = [
  "/aliado-1.png",
  "/aliado-2.png",
  "/aliado-3.png",
  "/aliado-4.png",
  "/aliado-5.png",
  "/aliado-6.png",
  "/aliado-7.png",
  "/aliado-8.png",
  "/aliado-9.png",
  "/aliado-10.png",
];

export default function Proyecto() {
  return (
    <section id="proyecto" data-testid="section-proyecto" className="py-24 sm:py-32 bg-white border-t border-[#e2dccd]">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <Reveal>
          <h2 className="font-display uppercase text-[#C20A78] text-5xl sm:text-7xl lg:text-8xl max-w-5xl mx-auto text-center">
            Más que una película,
            <br />
            un programa cultural y educativo
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-8 max-w-4xl mx-auto text-center space-y-5 text-base sm:text-lg leading-relaxed text-[#141414]/85">
            <p>
              Queremos que Niñagordita sea más que una película, queremos que
              sea un movimiento.
            </p>
            <p>
              Un movimiento que ponga en claro, de una vez por todas, que el valor de
              una chica no se mide en relación con el canon de belleza de turno, y que
              ninguna debería aprender que es necesario hacerse pequeña para merecer
              ser amada. Para ello, hemos generado un{" "}
              <strong className="font-semibold text-[#141414]">
                programa de impacto cultural y educativo
              </strong>{" "}
              que busca utilizar el cine peruano como herramienta de
              reflexión, toma de conciencia y llamado al fortalecimiento de la
              autoestima en adolescentes y jóvenes adultas.
            </p>
            <p>
              El libro publicado en 2022 agotó sus primeras ediciones y generó decenas
              de mensajes espontáneos de lectoras que se sintieron reflejadas,
              acompañadas, comprendidas.
            </p>
            <p>
              Con la película queremos ampliar ese alcance de forma exponencial,
              llegando a miles de jóvenes en Lima y regiones, ofreciendo además
              actividades educativas y talleres, acceso gratuito a la cultura y
              espacios seguros de conversación.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 bg-[#F2EDE3] rounded-2xl p-8 sm:p-10">
            <h3 className="font-display text-3xl sm:text-4xl text-[#6E6A66] uppercase">
              Objetivos del programa
            </h3>
            <ul className="mt-6 space-y-5">
              {objetivos.map((o, idx) => (
                <li key={idx} className="flex gap-4">
                  <span className="font-display text-2xl text-[#C20A78] leading-none shrink-0">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                  <span className="text-base sm:text-lg text-[#141414]/85 leading-relaxed">{o}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-10 max-w-4xl mx-auto text-center text-base sm:text-lg leading-relaxed text-[#141414]/85">
            El costo de no actuar es alto: miles de adolescentes y jóvenes adultas ven
            limitado su potencial por inseguridades sembradas en la adolescencia,
            afectando su bienestar, su salud mental y sus oportunidades futuras.
          </p>
        </Reveal>

        {/* Nuestros aliados y auspiciadores */}
        <Reveal delay={0.1}>
          <div id="aliados" className="mt-20 sm:mt-28 pt-14 sm:pt-16 border-t border-[#e2dccd] scroll-mt-[84px]">
            <SectionTitle tone="gray" className="text-center text-4xl sm:text-5xl lg:text-6xl">
              Nuestros aliados y auspiciadores
            </SectionTitle>

            <p className="mt-12 text-center text-xs sm:text-sm font-semibold tracking-[0.32em] uppercase text-[#6E6A66]">
              Aliados institucionales
            </p>
            <div className="mt-8 bg-white rounded-2xl border border-[#ece5d6] p-8 sm:p-12">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-8 gap-y-10 items-center justify-items-center">
                {aliados.map((src, i) => (
                  <img
                    key={src}
                    src={src}
                    alt={`Aliado institucional ${i + 1}`}
                    className="max-h-14 sm:max-h-16 w-auto object-contain"
                    draggable={false}
                  />
                ))}
              </div>
            </div>

            <p className="mt-14 text-center text-xs sm:text-sm font-semibold tracking-[0.32em] uppercase text-[#6E6A66]">
              Con el auspicio de
            </p>
            <div className="mt-6 flex justify-center">
              <img
                src="/auspicio-falabella.png"
                alt="Falabella — auspiciador"
                className="max-h-12 sm:max-h-14 w-auto object-contain"
                draggable={false}
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
